"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.logoutRequest = exports.loginRequest = exports.httpRequest = exports.replaceStrInPath = exports.addComponentJsonpath = undefined;

var _commons = require("./commons");

var _api = require("./api");

exports.addComponentJsonpath = _commons.addComponentJsonpath;
exports.replaceStrInPath = _commons.replaceStrInPath;
exports.httpRequest = _api.httpRequest;
exports.loginRequest = _api.loginRequest;
exports.logoutRequest = _api.logoutRequest;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-framework/ui-utils/index.js
// module id = ../lib/egov-ui-framework/ui-utils/index.js
// module chunks = 504